import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { resetPassword } from "../../../core/api/forgotPassword";
import { toast } from "react-toastify";

const ResetPassword3 = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordResponceText, setPasswordResponceText] = useState(
    "Use 8 or more characters with a mix of letters, numbers, and symbols."
  );

  const togglePasswordVisibility = (field: "password" | "confirmPassword") => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const onChangePassword = (password: string) => {
    setPassword(password);

    if (!password || password.trim() === "") {
      setPasswordResponceText(
        "Password cannot be empty or contain only spaces."
      );
    } else if (password.length < 8) {
      setPasswordResponceText("Password must be at least 8 characters.");
    } else if (!/[A-Za-z]/.test(password)) {
      setPasswordResponceText("Password must contain at least one letter.");
    } else if (!/\d/.test(password)) {
      setPasswordResponceText("Password must contain at least one number.");
    } else if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password)) {
      setPasswordResponceText(
        "Password must contain at least one special character."
      );
    } else {
      setPasswordResponceText("Awesome! You have a secure password.");
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");

    if (!password || !confirmPassword) {
      setErrorMessage("Both password fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    if (!token) {
      setErrorMessage("Reset token is missing or invalid.");
      navigate(routes.forgotPassword);
      return;
    }

    try {
      setLoading(true);
      await resetPassword(token, password);
      toast.success("Password reset successful. Please login.");
      window.history.replaceState({}, document.title, "/reset-password");
      setTimeout(() => navigate(routes.login), 1500);
    } catch (err: any) {
      const errorMsg = err?.message || "Failed to reset password.";
      if (
        errorMsg.toLowerCase().includes("invalid token") ||
        errorMsg.toLowerCase().includes("expired")
      ) {
        navigate(routes.forgotPassword);
      } else {
        setErrorMessage(errorMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
          <div className="col-md-4 mx-auto vh-100">
            <form onSubmit={handleSubmit} className="vh-100">
              <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                <div className="mx-auto mb-5 text-center">
                  <ImageWithBasePath
                    src="assets/img/logo.svg"
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div>
                  <div className="text-center mb-3">
                    <h2 className="mb-2">Reset Password</h2>
                    <p className="mb-0">
                      Your new password must be different from previously used
                      passwords.
                    </p>
                  </div>
                  <div>
                    <div className="input-block mb-3">
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="pass-group" id="passwordInput">
                          <input
                            type={
                              passwordVisibility.password ? "text" : "password"
                            }
                            value={password}
                            onChange={(e) => onChangePassword(e.target.value)}
                            className="form-control pass-input"
                            placeholder="Enter your password"
                          />
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() => togglePasswordVisibility("password")}
                            style={{ cursor: "pointer" }}
                          ></span>
                        </div>
                      </div>

                      <p
                        className="fs-12"
                        style={{
                          color: passwordResponceText.includes("Awesome")
                            ? "green"
                            : "#777",
                        }}
                      >
                        {passwordResponceText}
                      </p>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <div className="pass-group">
                        <input
                          type={
                            passwordVisibility.confirmPassword
                              ? "text"
                              : "password"
                          }
                          className="pass-input form-control"
                          placeholder="Confirm your password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <span
                          className={`ti toggle-passwords ${
                            passwordVisibility.confirmPassword
                              ? "ti-eye"
                              : "ti-eye-off"
                          }`}
                          onClick={() =>
                            togglePasswordVisibility("confirmPassword")
                          }
                          style={{ cursor: "pointer" }}
                        ></span>
                      </div>
                    </div>

                    {errorMessage && (
                      <p className="text-danger fs-12">{errorMessage}</p>
                    )}

                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mt-5 pb-4 text-center">
                  <p className="mb-0 text-gray-9">Copyright © 2025 - IATT</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword3;
